import Store from '../Store';
import structure from '../../data/ressources/PurchaseOrders';

const localUserData = localStorage.getItem('userData') || '';
const userData = localUserData ? JSON.parse(localUserData) : '';

const PurchaseOrderStore = new Store(`purchase/ordersbyuser/${userData?.user?.id || ''}`, structure);

export {PurchaseOrderStore};